document.addEventListener('DOMContentLoaded', function() {
  const headerElement = document.querySelector('#header');

  let lastLinkElement = null;
  function openSub(event) {
    if (!headerElement.classList.contains('l-header--navigation-expanded')) {
      // mobile only
      return;
    }

    event.preventDefault();
    const linkElement = event.target;

    const doubleEvent = lastLinkElement && lastLinkElement.element == linkElement && lastLinkElement.event_type != event.type;
    lastLinkElement = {element: linkElement, event_type: event.type};
    if (doubleEvent) {
      return;
    }
    lastSublinkElement = null;

    const subElement = linkElement.nextElementSibling;
    if (subElement.classList.contains('l-navigation__sub--visible')) {
      subElement.parentElement.classList.remove('l-navigation__item--subexpanded');
      subElement.classList.remove('l-navigation__sub--visible');
    }
    else {
      const subsElements = document.querySelectorAll('.l-navigation__sub--visible');
      subsElements.forEach((subElement) => {
        subElement.classList.remove('l-navigation__sub--visible');
        subElement.parentElement.classList.remove('l-navigation__item--subexpanded');
      });

      linkElement.parentElement.classList.add('l-navigation__item--subexpanded');
      subElement.classList.add('l-navigation__sub--visible');
    }
  }

  const linksElements = document.querySelectorAll('.js-navigation-sub .js-navigation-link');
  linksElements.forEach((linkElement) => {
    linkElement.addEventListener('focus', openSub);
    linkElement.addEventListener('click', openSub);
  });

  let lastSublinkElement = null;
  function openSide(event) {
    if (!headerElement.classList.contains('l-header--navigation-expanded')) {
      // mobile only
      return;
    }

    event.preventDefault();
    const sublinkElement = event.target;

    const doubleEvent = lastSublinkElement && lastSublinkElement.element == sublinkElement && lastSublinkElement.event_type != event.type;
    lastSublinkElement = {element: sublinkElement, event_type: event.type};
    if (doubleEvent) {
      return;
    }

    const sideElement = sublinkElement.nextElementSibling;
    if (sideElement.classList.contains('l-navigation__side--visible')) {
      sublinkElement.parentElement.classList.remove('l-navigation__subitem--sideexpanded');
      sideElement.classList.remove('l-navigation__side--visible');
    }
    else {
      const sidesElements = document.querySelectorAll('.l-navigation__side--visible');
      sidesElements.forEach((sideElement) => {
        sideElement.classList.remove('l-navigation__side--visible');
        sideElement.parentElement.classList.remove('l-navigation__subitem--sideexpanded');
      });

      sublinkElement.parentElement.classList.add('l-navigation__subitem--sideexpanded');
      sideElement.classList.add('l-navigation__side--visible');
    }
  }

  const sublinksElements = document.querySelectorAll('.js-navigation-side .js-navigation-sublink');
  sublinksElements.forEach((sublinkElement) => {
    sublinkElement.addEventListener('focus', openSide);
    sublinkElement.addEventListener('click', openSide);
  });
});
